// Countdown timer optimized to avoid work while the block is off-screen.
if (!customElements.get('tk-countdown')) {
  customElements.define(
    'tk-countdown',
    class extends HTMLElement {
      connectedCallback() {
        this.target = new Date(this.dataset.ends).getTime();
        if (Number.isNaN(this.target)) return;

        this.fields = {};
        this.querySelectorAll('[data-unit]').forEach((el) => {
          this.fields[el.dataset.unit] = el;
        });
        this.units = this.querySelector('.tk-flash__units');
        this.over = this.querySelector('.tk-flash__over');

        this.onVisibilityChange = () => {
          if (document.hidden) this.stop();
          else if (this.isVisible) this.start();
        };
        document.addEventListener('visibilitychange', this.onVisibilityChange);

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(
            (entries) => {
              this.isVisible = Boolean(entries[0]?.isIntersecting);
              if (this.isVisible && !document.hidden) this.start();
              else this.stop();
            },
            { rootMargin: '200px 0px' }
          );
          this.observer.observe(this);
        } else {
          this.isVisible = true;
          this.start();
        }
      }

      disconnectedCallback() {
        this.stop();
        this.observer?.disconnect();
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
      }

      start() {
        if (this.timer) return;
        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
      }

      stop() {
        if (!this.timer) return;
        clearInterval(this.timer);
        this.timer = undefined;
      }

      tick() {
        const left = this.target - Date.now();
        if (left <= 0) {
          this.stop();
          this.finish();
          return;
        }

        const s = Math.floor(left / 1000);
        this.set('days', Math.floor(s / 86400));
        this.set('hours', Math.floor((s % 86400) / 3600));
        this.set('minutes', Math.floor((s % 3600) / 60));
        this.set('seconds', s % 60);
      }

      set(unit, value) {
        const el = this.fields[unit];
        const next = String(value).padStart(2, '0');
        if (el && el.textContent !== next) el.textContent = next;
      }

      finish() {
        if (this.dataset.expired === 'hide') {
          const block = this.closest('.tk-flash');
          if (block) block.hidden = true;
          return;
        }
        Object.values(this.fields).forEach((el) => {
          el.textContent = '00';
        });
        if (this.dataset.expired === 'message' && this.over) {
          this.units.hidden = true;
          this.over.hidden = false;
        }
      }
    }
  );
}
